import { connect, } from 'react-redux'
import { bindActionCreators, } from 'redux'

import { createTrip, navEditTrip, } from 'redux/actions'
import { existingTripIds, } from 'redux/reducers'
import Component from './component'

const mapStateToProps = state => ({
  existingTripIds: existingTripIds(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ createTrip, navEditTrip, }, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./src/components/_sceneManager/Scenes/TripScene/AddTripScene/index.js